import SuccessStoryIcon from 'assets/images/funds/successStory.svg'

// «بزودی» is a chip, not a button: it was a <button> with no handler, and a
// button that does nothing when tapped is how a screen teaches people that
// tapping things here is pointless.
export default function SuccessStory() {
    return (
        <div className="flex items-center gap-3 bg-brand-soft rounded-card p-4 text-right">
            <img
                src={SuccessStoryIcon}
                alt=""
                className="h-14 w-auto shrink-0 object-contain"
            />
            <div className="flex-1 min-w-0">
                <p className="text-base font-bold text-heading truncate leading-snug">
                    داستان موفقیت صندوق‌ها
                </p>
                <p className="text-[13px] font-medium text-text-secondary mt-[2px] truncate">
                    مدیریت صندوق به سبک حرفه‌ای‌ها
                </p>
            </div>
            <span className="shrink-0 bg-white rounded-full px-3 py-1 text-xs font-bold text-brand-deep">
                بزودی
            </span>
        </div>
    )
}
